import { FormControlLabel, Checkbox } from '@material-ui/core';
import React from 'react';

const BuzzCheckbox = ({
  indeterminate = false,
  name = '',
  label = '',
  color = 'primary',
  onChange = () => {},
  checked = false,
  disabled = false,
  type = 'checkbox',
  ...rest
}) => {
  return (
    <FormControlLabel
      disabled={disabled}
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          name={name}
          indeterminate={indeterminate}
          color={color}
          type={type}
          {...rest}
        />
      }
      label={label}
    />
  );
};

export default BuzzCheckbox;
